import apiClient from '../../../services/apiClient';
import API_ENDPOINTS from '../../../config/api';
import useSubscriptionStore from '../../../store/subscriptionStore';

/**
 * Fetch available plans (public).
 */
export async function fetchPlans() {
  const store = useSubscriptionStore.getState();
  store.setLoadingPlans(true);
  try {
    const response = await apiClient.get(API_ENDPOINTS.GET_PLANS);
    store.setPlans(response.data.plans);
    return response.data.plans;
  } catch (error: any) {
    store.setError(error.response?.data?.error || 'Failed to fetch plans');
    throw error;
  } finally {
    store.setLoadingPlans(false);
  }
}

/**
 * Create a Stripe Checkout Session for a subscription plan.
 */
export async function createCheckoutSession(planKey: string, billing: 'monthly' | 'annual' = 'monthly') {
  const response = await apiClient.post(API_ENDPOINTS.CREATE_CHECKOUT_SESSION, { planKey, billing });
  return response.data; // { url, sessionId }
}

/**
 * Create a Stripe Customer Portal session.
 */
export async function createPortalSession() {
  const response = await apiClient.post(API_ENDPOINTS.CREATE_PORTAL_SESSION);
  return response.data; // { url }
}

/**
 * Fetch current subscription status.
 */
export async function fetchSubscriptionStatus() {
  const store = useSubscriptionStore.getState();
  store.setLoadingStatus(true);
  try {
    const response = await apiClient.get(API_ENDPOINTS.GET_SUBSCRIPTION_STATUS);
    store.setStatus(response.data);
    return response.data;
  } catch (error: any) {
    store.setError(error.response?.data?.error || 'Failed to fetch subscription status');
    throw error;
  } finally {
    store.setLoadingStatus(false);
  }
}

/**
 * Create a PaymentIntent for a PAYG credit pack.
 */
export async function createPaygIntent(packKey: string) {
  const response = await apiClient.post(API_ENDPOINTS.CREATE_PAYG_INTENT, { packKey });
  return response.data; // { clientSecret }
}
